import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../shared/services/logging';
import { EfaactDynamicDataService } from '../efaact.dynamic-data-service';
import { InvoiceRegisterModel } from './invoice-register.model';

export const entityName = 'InvoiceRegister';
@Injectable({ providedIn: 'root' })
export class InvoiceRegisterDataService extends EfaactDynamicDataService<InvoiceRegisterModel> {
    mapItems(item: InvoiceRegisterModel): InvoiceRegisterModel {
        // item = super.mapItems(item);
        return {
            ...item,
            id: `${item.IBO_ID}-${item.InvoiceNbr}-${item.CalcType}`
            // LoadedAmt:
            //     item.InvoiceAmount +
            //     item.FRCost +
            //     item.OHCost +
            //     item.GACost +
            //     item.MHCost,
            // Total:
            //     item.InvoiceAmount +
            //     item.FRCost +
            //     item.OHCost +
            //     item.GACost +
            //     item.MHCost +
            //     item.FeeCost
        } as any;
    }

    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }
}
